import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownProps = {
  tone?: 'light' | 'dark';
};
export function Countdown({
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const isDark = tone === 'dark';
  const units = [{
    value: hours,
    label: 'Hours'
  }, {
    value: minutes,
    label: 'Min'
  }, {
    value: seconds,
    label: 'Sec'
  }];
  return <div className="flex flex-col items-center" role="timer" aria-live="off" data-id="element-84" data-mp="3c3z14y5dj0ca">
      <p className={`flex items-center gap-2 text-sm font-bold uppercase tracking-wider ${isDark ? 'text-gold-light' : 'text-gold-dark'}`} data-id="element-85" data-mp="3h2jzes12f9y3">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-86" data-mp="373ugqx1chlgs" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2" data-id="element-87" data-mp="10dekfqcbl5v8">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-88" data-mp="15bof7zu4u4gb" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-89" data-mp="15an1fnlqf3uw">
              <span className={`flex h-[68px] w-[72px] items-center justify-center rounded-xl font-serif text-4xl font-bold tabular-nums ${isDark ? 'bg-gold text-ink' : 'bg-ink text-gold-light'}`} data-id="element-90" data-mp="y0enrustpzyb">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-widest ${isDark ? 'text-white/60' : 'text-muted'}`} data-id="element-91" data-mp="12sy592umtf8e">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold ${isDark ? 'text-gold' : 'text-ink'}`} aria-hidden="true" data-id="element-92" data-mp="o3s8dlj9o13o">
                :
              </span>}
          </React.Fragment>)}
      </div>
      <p className={`mt-3 text-sm ${isDark ? 'text-white/70' : 'text-muted'}`} data-id="element-93" data-mp="1vhc0xby8zzgs">
        Limited introductory pricing available.
      </p>
    </div>;
}